import React, { useState } from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

export default function Range({ uniqueId, startValue, endValue }) {
    const min = Number(startValue?.value ?? 0);
    const max = Number(endValue?.value ?? 100);
    const mid = Math.round((min + max) / 2);
    const [value, setValue] = useState([min, mid]);

    const handleChange = (newValue) => {
        setValue([min, newValue[1]]);
    };

    return (
        <div className="range-slider-custom">
            <RangeSlider
                id={uniqueId}
                value={value}
                min={min}
                max={max}
                step={1}
                onInput={handleChange}
                thumbsDisabled={[true, false]}
            />
        </div>
    );
}
